// @ts-check
import { log } from './console.js';

/* Unifies current page detection logic */

export const PAGE_ID = {
  b2c: {
    productListing: 'b2c-product-listing',
    range: 'b2c-range',
    pdp: 'b2c-pdp',
    cart: 'b2c-cart',
  },

  b2b: {
    allProducts: 'b2b-all-products',
    categoryListing: 'b2b-category-listing',
    category: 'b2b-category',
    range: 'b2b-range',
    rangeProducts: 'b2b-range-products',
    rangePresentation: 'b2b-range-presentation',
    rangeDownloads: 'b2b-range-downloads',
    pdp: 'b2b-pdp',
    cart: 'b2b-cart',
  },

  productComparator: 'product-comparator',
};

/**
 * @param {string} id
 * @returns {boolean}
 */
function bodyIdMatches(id) {
  return document.body.id === id;
}

/**
 * @param {string} pathPart
 * @returns {boolean}
 */
function urlPartMatches(pathPart) {
  return window.location.pathname.indexOf(pathPart) !== -1;
}

/**
 * @param {string} selector
 * @returns {boolean}
 */
function elementExists(selector) {
  return document.querySelector(selector) !== null;
}

/**
 * Check if current page is one with ID `pageId`.
 *
 * @param {string | Array<string>} pageId Page ID or array of page IDs.
 * @returns {boolean}
 */
export function isPage(pageId) {
  if (Array.isArray(pageId)) {
    return pageId.some(isPage);
  }

  switch (pageId) {
    case PAGE_ID.b2c.productListing:
      return urlPartMatches('/home/product-listing');

    case PAGE_ID.b2c.range:
      return elementExists('.listing-page__container');

    case PAGE_ID.b2c.pdp:
      return document.body.matches('.b2c-product-datasheet');

    case PAGE_ID.b2c.cart:
      return urlPartMatches('/home/product-cart');

    case PAGE_ID.b2b.allProducts:
      return bodyIdMatches('all-products');

    case PAGE_ID.b2b.categoryListing:
      return elementExists('.b2b-category-listing');

    case PAGE_ID.b2b.category:
      return elementExists('.b2b-product-category');

    case PAGE_ID.b2b.range:
      return bodyIdMatches('product-range');

    case PAGE_ID.b2b.rangeProducts:
      return elementExists('.js-range-products');

    case PAGE_ID.b2b.rangePresentation:
      return elementExists('.js-presentation-content');

    case PAGE_ID.b2b.rangeDownloads:
      return urlPartMatches('product-range-download');

    case PAGE_ID.b2b.rangeSoftwareRegistration:
      return urlPartMatches('product-range-software_registration');

    case PAGE_ID.b2b.pdp:
      return bodyIdMatches('product-datasheet');

    case PAGE_ID.b2b.cart:
      return bodyIdMatches('my-cart');

    case PAGE_ID.productComparator:
      return bodyIdMatches('product-comparator');

    default:
      log.warn(`Unknown page ID ${pageId}`);
      return false;
  }
}

export function isB2CPage() {
  return isPage(Object.values(PAGE_ID.b2c));
}

export function isB2BPage() {
  return isPage(Object.values(PAGE_ID.b2b));
}
